import {
  AppData,
  AppDataComponent,
  CompRef,
  DocumentServicesObject,
} from '@wix/document-services-types';
import { EditorPointer, EditorPointerAPI } from '@wix/editorx-core-api';

function getCompTypeFromEditorPointer(
  editorPointer: EditorPointer<CompRef>,
  editorPointerAPI: EditorPointerAPI,
  documentServicesAPI: DocumentServicesObject,
) {
  const compRef = editorPointerAPI.getDocumentPointer(editorPointer);

  return documentServicesAPI.components.getType(compRef);
}

// TODO: remove this once the manifest has the default behaviors for top level elements
function isTopLevelElement(
  editorPointer: EditorPointer<CompRef>,
  editorPointerAPI: EditorPointerAPI,
) {
  const innerElementPath = editorPointerAPI.getInnerElementPath(editorPointer);
  return !innerElementPath || innerElementPath.length <= 1;
}

function isBuilderComponentType(compType: string) {
  return compType.startsWith('platform.builder');
}

function findBuilderComponentTypes(appData?: AppData): string[] {
  if (!appData?.components) {
    return [];
  }

  return appData.components.reduce(
    (acc: string[], component: AppDataComponent) => {
      if (
        // @ts-expect-error no componentModel in the AppDataComponent type
        isBuilderComponentType(component.data?.componentModel.componentType)
      ) {
        // @ts-expect-error no componentModel in the AppDataComponent type
        acc.push(component.data?.componentModel.componentType);
      }
      return acc;
    },
    [],
  );
}

function getComponentTypesOnPage(
  documentServicesAPI: DocumentServicesObject,
  pageRef: CompRef,
) {
  return documentServicesAPI.components
    .getChildren(pageRef, true)
    .reduce((acc: string[], compRef: CompRef) => {
      const compType = documentServicesAPI.components.getType(compRef);
      if (isBuilderComponentType(compType)) {
        acc.push(compType);
      }
      return acc;
    }, []);
}

function getComponentsOnCurrentPage(
  documentServicesAPI: DocumentServicesObject,
) {
  const currentPageRef = documentServicesAPI.pages.getCurrentPage();
  return getComponentTypesOnPage(documentServicesAPI, currentPageRef);
}

function getEditorPointersFromCompTypes(
  documentServicesAPI: DocumentServicesObject,
  editorPointerAPI: EditorPointerAPI,
  compTypes: string[],
) {
  return compTypes
    .flatMap((compType) => documentServicesAPI.components.get.byType(compType))
    .map((compRef) =>
      editorPointerAPI.buildEditorPointer(compRef, [compRef.id]),
    );
}

function handleErrors(error: Error) {
  // TODO: handle errors in a proper way
  console.error(error);
}

export {
  getCompTypeFromEditorPointer,
  isTopLevelElement,
  isBuilderComponentType,
  findBuilderComponentTypes,
  getComponentsOnCurrentPage,
  getEditorPointersFromCompTypes,
  handleErrors,
};
